export { default as Img200 } from './processed/200/Black-Beauty.jpg';
export { default as Img400 } from './processed/400/Black-Beauty.jpg';
export { default as Imgthumb } from './processed/thumb/Black-Beauty.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Black-Beauty.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Black-Beauty.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      4,
      116,
      252
    ],
    "_population": 4033,
    "_hsl": [
      0.5913978494623656,
      0.9763779527559056,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      121,
      196,
      245
    ],
    "_population": 943,
    "_hsl": [
      0.5658602150537634,
      0.8611111111111114,
      0.7176470588235294
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      86,
      51,
      18
    ],
    "_population": 1167,
    "_hsl": [
      0.08088235294117646,
      0.653846153846154,
      0.20392156862745098
    ]
  },
  "Muted": {
    "_rgb": [
      129,
      125,
      88
    ],
    "_population": 171,
    "_hsl": [
      0.15040650406504066,
      0.1889400921658986,
      0.42549019607843136
    ]
  },
  "LightMuted": {
    "_rgb": [
      206,
      215,
      222
    ],
    "_population": 3769,
    "_hsl": [
      0.5729166666666666,
      0.1951219512195122,
      0.8392156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      64,
      91
    ],
    "_population": 263,
    "_hsl": [
      0.691358024691358,
      0.17419354838709677,
      0.303921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Black-Beauty.js